import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { takeGoogleMode } from "@/lib/google";
import { clearInvite, getInvite } from "@/lib/invite";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const mode = takeGoogleMode();
    const invite = getInvite();
    const codeFromPath = window.location.pathname.match(/^\/i\/([^/]+)/)?.[1];
    const target = mode === "link" ? "/conecta/config" : mode === "invite" ? "/conecta" : "/";
    window.history.replaceState(null, "", window.location.pathname);
    const extra = mode === "invite" ? { codigo: codeFromPath || invite?.codigo, inv: null } : {};
    api.post("/auth/google", { session_id: sessionId, mode, ...extra })
      .then(({ data }) => {
        setUser(data.user);
        if (mode === "link") toast.success(`Google vinculado: ${data.user.google_email}`);
        else if (data.created) { clearInvite(); toast.success("Cuenta creada con Google"); }
        nav(target, { replace: true });
      })
      .catch((e) => {
        setError(errMsg(e));
        toast.error(errMsg(e));
        if (mode === "link") nav(target, { replace: true });
        else api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false))
          .finally(() => nav(mode === "invite" && codeFromPath ? `/i/${codeFromPath}/registro` : "/login", { replace: true }));
      });
  }, [nav, setUser]);
  return (
    <div data-testid="auth-callback" className="min-h-screen flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-6 h-6 animate-spin c-muted" />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
